import { DateTime } from 'luxon'
import { uiOptions } from '@/config'

/**
 *
 * @param date
 * @param formatOption Format options: https://moment.github.io/luxon/#/formatting?id=table-of-tokens
 + default format option: 'DD' localized date with abbreviated month 'Aug 6, 2014'
 */
export function convertDateToDateTimeWithFormatOption(
  date: Date | DateTime,
  formatOption: string | Intl.DateTimeFormatOptions = 'DD'
) {
  if (date instanceof Date) {
    date = DateTime.fromJSDate(date)
  }
  date = date.setLocale(uiOptions().location.languageTag)

  if (typeof formatOption === 'string') {
    return date.toFormat(formatOption)
  } else {
    return date.toLocaleString(formatOption)
  }
}
